import { render, staticRenderFns } from "./credit-report-bureaus-modal.vue?vue&type=template&id=1122fdb0&scoped=true&"
import script from "./credit-report-bureaus-modal.vue?vue&type=script&lang=js&"
export * from "./credit-report-bureaus-modal.vue?vue&type=script&lang=js&"
import style0 from "./credit-report-bureaus-modal.vue?vue&type=style&index=0&id=1122fdb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122fdb0",
  null
  
)

export default component.exports